<template>
  <ul>
    <li v-for="(item, index) in itemsWithText" :key="index" :class="item.text && `mb-${customMargin} last:mb-0`">
      <div class="flex items-center gap-8">
        <component :is="item.icon" :color="iconColor" :width="iconSize" :height="iconSize" aria-hidden="true" />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p :class="[textClasses, item.clickHandler && 'cursor-pointer']" @click="handleClick(item)" v-html="item.text" />
        <slot name="icon" :item="item" />
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { Component } from 'vue';

export default {
  name: 'IconList',
  props: {
    items: {
      type: Array as () => Array<{ icon: Component; text: string; clickHandler?: Function }>,
      required: true,
    },
    iconColor: {
      type: String,
      default: '#282930',
    },
    iconSize: {
      type: Number,
      default: 24,
    },
    textClasses: {
      type: String,
      default: 'text-body text-grey-body',
    },
    customMargin: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    itemsWithText() {
      return this.items.filter((item) => item.text);
    },
  },
  methods: {
    handleClick(item) {
      if (item.clickHandler) {
        this.$emit('item-click', item);
      }
    },
  },
};
</script>
